module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "admin-page"
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    attrs: {
      "to": "/clienteform"
    }
  }, [_vm._v("Nuevo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.clientes), function(cliente) {
    return _c('tr', {
      key: cliente._id
    }, [_c('td', [_vm._v(_vm._s(cliente.razonSocial))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("formatFecha")(cliente.fechaAlta)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "button-group"
    }, [_c('ul', {
      staticClass: "table-actions smart-form"
    }, [_c('li', [_c('router-link', {
      staticClass: "btn btn-xs btn-ghost",
      attrs: {
        "to": ("/clienteform/edit/" + (cliente._id)),
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-actions fa-edit"
    })])], 1)])])])])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Razón social")]), _vm._v(" "), _c('th', [_vm._v("Fecha alta")]), _vm._v(" "), _c('th', [_vm._v("Acciones")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0d0f504"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clientes/ListaClientes.vue
// module id = 1164
// module chunks = 5